module.exports = __webpack_public_path__ + "img/demolition_lab_small.d15b7814.png";